import React from "react";
import { useLanguage } from "@/contexts/LanguageContext";
import { Project } from "@/types";
import { CategoryType } from "@/types/category";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import getProjectTranslation from "@/utils/getProjectTranslation";

interface ProjectFilterProps {
  projects: Project[];
  selectedCategory?: CategoryType;
  onCategoryChange: (category: CategoryType | undefined) => void;
  selectedProjectId?: string;
  onProjectChange: (projectId: string | undefined) => void;
}

const ProjectFilter: React.FC<ProjectFilterProps> = ({
  projects,
  selectedProjectId,
  onProjectChange,
}) => {
  const { t, language } = useLanguage();

  const handleProjectChange = (value: string) => {
    if (value === "all") {
      onProjectChange(undefined);
    } else {
      onProjectChange(value);
    }
  };

  return (
    <div className="flex flex-wrap items-end w-48">
      <Select
        value={selectedProjectId || "all"}
        onValueChange={handleProjectChange}
      >
        <SelectTrigger className="w-full bg-white border border-gray-300 h-11 text-left">
          <SelectValue placeholder={t("dashboard.filters.project")} />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all">
            {t("categoryOverview.filters.allProjects")}
          </SelectItem>
          {projects.map((project) => (
            <SelectItem key={project.id} value={project.id}>
              {getProjectTranslation(project.nameTranslations, language) || project.title}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
};

export default ProjectFilter;
